module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-154.ee99148.woff2";